<app-modal-panel #modalPanel headerTitle="SHARE" buttonTitle="SHARE" [allowSubmit]="shareForm.form.valid && myform.controls.email.valid &&  myform.controls.email.dirty" (submit)="share()">
    <div class="content">
  
    <div class="modal-body pt-0 pb-0">
        <div class="modal-content border-0">
            <form #shareForm="ngForm" novalidate (ngSubmit)="share()">
                <div class="row mb-2">
                    <div class="content-type col-sm-1">
                        <span>
                            <i class="icon" [class.icon-pdf]="data.contentType == fileType.Doc" [class.icon-play]="data.contentType == fileType.Video"
                               [class.icon-image]="data.contentType == fileType.Img" [class.icon-pdf]="!data.contentType" aria-hidden="true"></i>
                        </span>
                    </div>
                    <div class="content-name col-sm-5">
                        {{data.displayName}}
                    </div>
                    <div class="col-sm-6 text-right">
                        <div class="sub-info"><strong>ADDED: </strong>{{data.createdTime | date | uppercase}}</div>
                        <div class="sub-info"><strong>BY: </strong>{{data.author?.name | uppercase}}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 mb-1">
                        <span class='title'>Recipient Email*</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12" [formGroup]="myform">
                        <input inputFocus name="email" class="form-control border-0" formControlName="email"
                               type="email" [(ngModel)]="email" [attr.placeholder]="'name@email.com'"
                               required
                               [ngClass]="{
                               'has-danger': myform.controls.email.invalid &&  myform.controls.email.dirty, 
                               'has-success':  myform.controls.email.valid &&  myform.controls.email.dirty 
                               }"
                               >
                              
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 mt-3 mb-1">
                        <span class='title'>Your Message</span>
                    </div>
                </div>
                <div class="row">
                    <div class=	"col-sm-12 content-message">
                        <app-textarea-counter inputFocus name="message" class="form-control p-0 round-0" 
                                              [(ngModel)]="message" [maxLength]="300" [placeholder]="'Enter your message'"></app-textarea-counter>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
</app-modal-panel>
